import { render, staticRenderFns } from "./buyadditional.vue?vue&type=template&id=cb505968&scoped=true"
import script from "./buyadditional.vue?vue&type=script&lang=js"
export * from "./buyadditional.vue?vue&type=script&lang=js"
import style0 from "./buyadditional.vue?vue&type=style&index=0&id=cb505968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb505968",
  null
  
)

export default component.exports